import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Flame, X } from "lucide-react";

const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const endDate = new Date('2026-01-31T23:59:59');

    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = endDate.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        const rect = pricingSection.getBoundingClientRect();
        const isPastPricing = rect.bottom < 0;
        setIsVisible(isPastPricing && !isDismissed);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-fade-in">
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 shadow-lg border-t border-orange-400/20">
        <div className="max-w-5xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="hidden sm:flex items-center gap-1 text-white/90">
                <Flame className="w-4 h-4" />
                <span className="text-sm font-medium">LTD Offer ends:</span>
              </div>
              <div className="flex items-center gap-1 text-white font-mono text-sm">
                <span className="bg-white/20 px-2 py-1 rounded">{String(timeLeft.days).padStart(2, '0')}d</span>
                <span>:</span>
                <span className="bg-white/20 px-2 py-1 rounded">{String(timeLeft.hours).padStart(2, '0')}h</span>
                <span>:</span>
                <span className="bg-white/20 px-2 py-1 rounded">{String(timeLeft.minutes).padStart(2, '0')}m</span>
                <span>:</span>
                <span className="bg-white/20 px-2 py-1 rounded">{String(timeLeft.seconds).padStart(2, '0')}s</span>
              </div>
              <span className="hidden md:inline text-white/80 text-sm">Only 47 spots left!</span>
            </div>
            
            <div className="flex items-center gap-2">
              <Button 
                size="sm" 
                className="bg-white text-orange-600 hover:bg-white/90 font-medium"
                asChild
              >
                <a href="https://gum.co/localroute-premium" target="_blank" rel="noopener noreferrer">
                  Grab LTD - $9.99
                  <Flame className="w-3.5 h-3.5 ml-1" />
                </a>
              </Button>
              <button 
                onClick={() => setIsDismissed(true)}
                className="text-white/70 hover:text-white p-1"
                aria-label="Dismiss"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
